import { makeStyles } from "@material-ui/core/styles";

import { BASE_COLORS, FONT_SIZES } from "../../../../../../../../emotion-theme";
import styled from "@emotion/styled";

export const useFlyerDetailAddPageTemplateOptionStyles = makeStyles(() => ({
  checked: {
    border: `2px solid ${BASE_COLORS.paleBlue}`,
  },

  icon: {
    padding: "4px",
    borderRadius: "4px",
    boxShadow: "0 0 3px 3px #e9e9e9",
    width: "110px",
    height: "140px",
  },

  label: {
    marginBottom: "16px",
    marginRight: "15px",
  },

  radio: {
    borderRadius: "0",

    "&:hover": {
      backgroundColor: "transparent !important",

      "& $icon": {
        backgroundColor: "rgba(137, 230, 255, 0.04)",
      },
    },
  },
}));
export const TemplateName = styled.div`
  display: block;
  font-weight: 600;
  font-size: ${FONT_SIZES.small};
  text-align: center;
`;
